import { type CreateReturnLabelOrRefundResponseV1 } from '@redteclab/api/clients/composition-service-transactions'

import assert from 'shared/utils/assert'

import BackendAPIService from './BackendAPIService'
import type { ServiceParameters } from './commonTypes'
import type {
  ICreateReturnLabelRequestBodyV2,
  IReturnLabel,
  IReturnReasonResponse,
} from './models/returnLabel'

const config = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

const API_VERSION = 'v1'

class ReturnLabelService extends BackendAPIService {
  constructor(props: ServiceParameters) {
    super(props)

    this.apiVersion = API_VERSION
  }

  getReturnLabelUrl(subOrderId: string) {
    return `returnlabel/${this.apiVersion}/${this.tenantPath}/${subOrderId}`
  }

  getReturnLabelUrlV2(orderId: string, subOrderId: string) {
    return `returnlabel/v2/${this.tenantPath}/${orderId}/${subOrderId}`
  }

  getReturnLabelUrlV3(orderId: string, subOrderId: string) {
    return `returnlabel/v3/${this.tenantPath}/${orderId}/${subOrderId}`
  }

  async getReturnReasons() {
    const { data } = await this.get<IReturnReasonResponse>(
      `aftersales/${this.apiVersion}/${this.tenantPath}/return/reasons`,
      config
    )

    return data
  }

  getAfterSalesReturnUrl() {
    return `aftersales/${this.apiVersion}/${this.tenantPath}/return`
  }

  async getReturnLabel(subOrderId: string): Promise<IReturnLabel> {
    assert(
      subOrderId,
      'ReturnLabelService.getReturnLabelDoc: please provide "subOrderId"'
    )

    const { data } = await this.get<IReturnLabel>(
      this.getReturnLabelUrl(subOrderId),
      config
    )

    return data
  }

  async createReturnLabelV2(
    body: ICreateReturnLabelRequestBodyV2
  ): Promise<CreateReturnLabelOrRefundResponseV1> {
    assert(
      body.orderNumber,
      'ReturnLabelService.createReturnLabelV2: please provide "body.orderNumber"'
    )

    assert(
      body.subOrderId,
      'ReturnLabelService.createReturnLabelV2: please provide "body.subOrderId"'
    )

    assert(
      body.carrier,
      'ReturnLabelService.createReturnLabelV2: please provide "body.carrier"'
    )

    assert(
      body.items,
      'ReturnLabelService.createReturnLabelV2: please provide "body.items"'
    )

    const { data } = await this.post<
      ICreateReturnLabelRequestBodyV2,
      CreateReturnLabelOrRefundResponseV1
    >(this.getAfterSalesReturnUrl(), body, config)

    return data
  }
}

export default ReturnLabelService
